// extracted by mini-css-extract-plugin
module.exports = {"headerNav":"styles_headerNav__Scy6e","container":"styles_container__FwWs1","pageList":"styles_pageList__qPVb6","pagination":"styles_pagination__4ihtF"};